import type { BadgeTone } from '@/shared/components/ui/Badge';
import type { DemoStatus } from './types';

export const DEMO_STATUS_OPTIONS: { value: DemoStatus; label: string }[] = [
  { value: 'requested', label: 'Requested' },
  { value: 'assigned', label: 'Assigned' },
  { value: 'in_development', label: 'In Development' },
  { value: 'review', label: 'Review' },
  { value: 'approved', label: 'Approved' },
  { value: 'shared', label: 'Shared' },
  { value: 'delivered', label: 'Delivered' },
  { value: 'rejected', label: 'Rejected' },
  { value: 'closed', label: 'Closed' },
];

export const DEMO_STATUS_LABELS: Record<string, string> = {
  ...Object.fromEntries(DEMO_STATUS_OPTIONS.map((s) => [s.value, s.label])),
  pending: 'Pending',
  in_progress: 'In Progress',
};

export const DEMO_STATUS_TONES: Record<string, BadgeTone> = {
  requested: 'neutral',
  assigned: 'info',
  in_development: 'info',
  review: 'warning',
  approved: 'success',
  shared: 'primary',
  delivered: 'success',
  rejected: 'danger',
  closed: 'neutral',
  pending: 'neutral',
  in_progress: 'info',
};

export const DEMO_PRIORITY_OPTIONS = [
  { value: 'low', label: 'Low' },
  { value: 'medium', label: 'Medium' },
  { value: 'high', label: 'High' },
  { value: 'urgent', label: 'Urgent' },
];

export const DEMO_PRIORITY_TONES: Record<string, BadgeTone> = {
  low: 'neutral',
  medium: 'info',
  high: 'warning',
  urgent: 'danger',
};

export const PROJECT_TYPE_OPTIONS = [
  { value: 'website', label: 'Website' },
  { value: 'crm', label: 'CRM' },
  { value: 'erp', label: 'ERP' },
  { value: 'mobile_app', label: 'Mobile App' },
  { value: 'ecommerce', label: 'E-commerce' },
  { value: 'saas', label: 'SaaS' },
  { value: 'ai_tool', label: 'AI Tool' },
  { value: 'custom', label: 'Custom' },
];

export const FEEDBACK_STATUS_OPTIONS = [
  { value: 'accepted', label: 'Accepted' },
  { value: 'revision_required', label: 'Revision Required' },
  { value: 'rejected', label: 'Rejected' },
];

/** Mirrors the backend DEMO_PRIVILEGED check exactly. */
export function isDemoPrivileged(role?: string, department?: string): boolean {
  return role === 'superadmin' || role === 'admin' || department === 'it' || department === 'developer';
}

/**
 * Demo deletion is DISABLED pending a backend fix. The `demoRequestSchema`
 * pre('findOneAndDelete') hook is an async function that also calls next(),
 * which throws "next is not a function" → DELETE /api/demos/:id returns 500.
 * (Same cascade-hook defect family as Projects delete.) Flip to true once the
 * backend hook is fixed — no other frontend change required. See Backend Defect Report.
 */
export const DEMO_DELETE_ENABLED = false;
